import {Component, HostBinding, Input, OnInit, forwardRef, ViewChildren, ElementRef, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

import {DecimalPipe} from '@angular/common';

@Component({
    selector: 'app-price-input',
    templateUrl: './price-input.component.html',
    styleUrls: ['./price-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PriceInputComponent),
        multi: true
    }]
})
export class PriceInputComponent implements ControlValueAccessor {


    @Input()
    public placeholder: string;

    @Input()
    public showValidation: boolean;
    @Input()
    public isError: boolean;
    @Input()
    public disabled: boolean;

    @Input()
    public showIcon = true;

    @Input()
    public name: string;

    @Input()
    public formatStyle: 'THOUSAND' | 'DECIMAL';  // 123456,7890 will be formatted to ... for: THOUSAND: 123.456,78 ...for DECIMAL: 123456,78

    @Input()
    public step = 1;

    @HostBinding('class.force-form-validation-visibility')
    @Input()
    forceFormValidationVisibility = false;

    @Input()
    public min: number;

    @Input()
    public max: number;


    @ViewChild('inputElement', {static: true}) inputElement;

    public textValue = '';
    public propagateChange: (_: any) => void = (_: any) => {
    }
    public onTouched: () => void = () => {
    }

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }


    public writeValue(value: number): void {
        if (value || value === 0) {
            let newValue = value.toString();
            newValue = newValue.replace(/[.]/g, ',');
            this.textValue = this.formatTextValue(newValue);
        } else {
            this.textValue = '';
        }
    }



    public updateChanges(inputElement: HTMLInputElement): void {
        this.filterInput(inputElement);
        if (this.textValue !== inputElement.value) {
            this.textValue = inputElement.value;
        }

        const outputNumber =
            this.textValue !== null && this.textValue !== '' && this.textValue !== '-' ? this.toNumber(this.textValue) : null;
        this.propagateChange(outputNumber);
    }


    private toNumber(value: string): number {
        return +value.replace(/\./g, '').replace(/,/g, '.');
    }

    public onIconClicked() {

    }


    public filterInput(inputElement: HTMLInputElement) {

        if (!this.formatStyle) {
            return;
        }

        const position = inputElement.selectionStart;
        let reformatted = false;

        while (inputElement.value.match(/,,/)) {
            inputElement.value = inputElement.value.replace(/,,/g, ',');
            reformatted = true;
        }

        while (inputElement.value.match(/\.\./)) {
            inputElement.value = inputElement.value.replace(/\.\./g, '.');
            reformatted = true;
        }

        while (inputElement.value.match(/,.+,/)) {
            inputElement.value = inputElement.value.slice(0, inputElement.value.lastIndexOf(','));
            reformatted = true;
        }

        while (inputElement.value.match(/,.*\./)) {
            inputElement.value = inputElement.value.slice(0, inputElement.value.lastIndexOf('.'));
            reformatted = true;
        }

        if (inputElement.value.match(/[^\d.,]/)) {
            inputElement.value = inputElement.value.replace(/[^\d.,]/g, '');
            reformatted = true;

        }

        if (reformatted) {
            inputElement.setSelectionRange(position - 1, position - 1);
        }
    }


    public formatInputValue(inputElement: HTMLInputElement) {

        if (!this.formatStyle) {
            return;
        }
        inputElement.value = this.formatTextValue(inputElement.value);
    }

    private formatTextValue(textValue: string): string {
        const numberValue = this.toNumber(textValue);
        let newTextValue = new DecimalPipe('de-DE').transform(numberValue, '1.2-2');
        if (this.formatStyle === 'DECIMAL') {
            newTextValue = textValue.replace(/[.]/g, '');
        }
        return newTextValue;
    }


    public onBlur(inputElement: HTMLInputElement) {
        if (inputElement.value) {
            this.formatInputValue(inputElement);
        }

        if (this.toNumber(this.textValue) !== this.toNumber(inputElement.value)) {
            this.textValue = inputElement.value;
            this.propagateChange(this.toNumber(this.textValue));
        }

        this.onTouched();
    }
}
